import clsx from "clsx";

import { ProductItemInfo } from "./ItemInfo";
import { ProductItemSettings, type Props as ItemSettingsProps } from "./ItemSettings";

import type { JSX } from "react";

interface Props extends Omit<ItemSettingsProps, "onAddToCart" | "onSelect"> {
  name: string;
  printName?: string;
  store?: {
    id: string;
    name: string;
  };
  cardPaymentSettings?: {
    installments: number;
    value: number;
  };
  className?: string;
  storefront?: boolean;
  onAddToCart: () => void;
  setValues: (values: {
    blankId: string;
    color: { colorName: string; colorHex: string };
    size: string;
    quantity: number;
  }) => void;
}

export const ProductItemSelector = ({
  values,
  printName,
  name,
  store,
  price,
  cardPaymentSettings,
  colors,
  sizes,
  loading,
  className,
  errors,
  onAddToCart,
  setValues,
  storefront,
}: Props): JSX.Element => {
  return (
    <div className={clsx("justify-center max-lg:flex max-lg:w-full", className)}>
      <div className="w-full rounded-lg lg:max-w-[24.5rem]">
        <ProductItemInfo
          printName={printName}
          name={name}
          store={store}
          price={price}
          cardPaymentSettings={cardPaymentSettings}
          loading={loading}
          storefront={storefront}
        />

        <div className="mt-2 h-[1px] w-full bg-base-input" />

        <ProductItemSettings
          values={values}
          colors={colors}
          sizes={sizes}
          price={price}
          errors={errors}
          onAddToCart={onAddToCart}
          onSelect={setValues}
          loading={loading}
          storefront={storefront}
        />
      </div>
    </div>
  );
};
